mutation googleSetInitialSyncSettings($input: GoogleSetInitialSyncSettingsInput!) {
    googleSetInitialSyncSettings(input: $input) {
        success
        errorMessage
    }
}
